import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONBOARDING_VIEWS } from 'onboarding-settings-client/constants/onboardingViews';
import { trackPageView } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoAccessText = ({
  selectedView
}) => {
  switch (selectedView) {
    case ONBOARDING_VIEWS.MARKETING:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.helperText.marketing"
        });
      }
    case ONBOARDING_VIEWS.SALES:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.helperText.sales"
        });
      }
    case ONBOARDING_VIEWS.SERVICE:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.helperText.service"
        });
      }
    case ONBOARDING_VIEWS.CMS:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.helperText.cms"
        });
      }
    // fall back scenario
    default:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.helperText.default"
        });
      }
  }
};
export default function InvitedUserAccessErrorPage({
  selectedView
}) {
  useEffect(() => {
    trackPageView('view invited user access error page');
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "INVITED_USER_ACCESS_ERROR_SCREEN"
    }), /*#__PURE__*/_jsxs(ErrorMessage, {
      illustration: "keys",
      illustrationProps: {
        width: 102
      },
      title: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.title"
        })
      }),
      children: [/*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(NoAccessText, {
          selectedView: selectedView
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.error.invited.noAccess.description"
        })
      })]
    })]
  });
}